import React, {useState, useEffect, useContext} from 'react';
import {isEmpty} from 'lodash/lang';
import {withRouter} from 'react-router-dom';
import {addFlashMessage} from '../../actions/flash-message';
import {connect} from 'react-redux';
import {SentimentVerySatisfied as Happy, SentimentVeryDissatisfied as Sad} from '@material-ui/icons';
import {buildAnswers} from '../../utils/common';
import {Typography} from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import {fetchUserQuiz} from '../../api';
import {
    calculateScore,
} from './UserReports/utils';
import QuizHeader from './UserReports/QuizResultHeader';
import QuizOverview from './UserReports/QuizSummaryBreakdown';
import DetailedQuestionResult from './UserReports/DetailedQuestionResult';
import {LoadingContext} from '../../contexts/LoadingContext';
import {
    Button,
    ButtonGroup,
} from '@material-ui/core';

function QuizUserResult(props) {
    const {setLoading} = useContext(LoadingContext);
    const [{quizDataDict, answers}, setData] = useState({});
    const [userPassed, setUserPassed] = useState(false);
    const{addFlashMessage} = props;
    const [teacherView, setTeacherView] = useState(false);
    let data;
    if (props.location.state != null) {
        data = props.location.state.data;
    }

    const {match: {params: {quizUserId}}} = props;

    useEffect(() => {
        if (data != null) {
            setData({quizDataDict: data, answers: buildAnswers(data.questions)});
        }
    }, [data]);

    useEffect(() => {
        if (data == null && quizUserId != null) {
            setLoading(true);
            fetchUserQuiz(quizUserId).then(data => {
                setData({quizDataDict: data, answers: buildAnswers(data.questions)});
                setTeacherView(true);
            }).catch(err => addFlashMessage(`An error occurred: ${err.message}`)
            ).finally(() => setLoading(false));
        }
    }, [quizUserId]);

    useEffect( () => {
        setUserPassed(DeterminePassFail());
    }, [quizDataDict]);

    function DeterminePassFail(){
        if (quizDataDict) {
            return calculateScore(quizDataDict) >= quizDataDict.options.passFailThreshold;
        }
        return false;
    }

    if (isEmpty(quizDataDict)) {
        return null;
    }

    const determineFeedback = (options) => {
        let feedback = options.showRecapCorrect ? 'full' :
            options.showRecap ? 'detailed' : options.showRecapResults ? 'summary' : 'none';
        return feedback;
    };

    let feedback = determineFeedback(quizDataDict.options);
    const {endMessage} = quizDataDict;

    return (
        <div className={`content-box${(feedback === 'none' ? endMessage ? '' : ' vertical-align-center-ish' : '')}`}>
            {endMessage && <div className="end-quiz-message" dangerouslySetInnerHTML={{__html: endMessage}}></div>}
            {(feedback === 'none' && !teacherView) && <QuizSubmitted returnTo={quizDataDict.returnTo}/>}
            {(feedback !== 'none' || teacherView) &&
                <>
                <Typography color="primary" variant="h4">{quizDataDict.name}</Typography>
                {quizDataDict.questions.length < 1 ? <p>No questions are available.</p> :
                    <p>Total questions: {quizDataDict.questions.length}</p>}
                <Typography variant="h5">
                    {!teacherView && 'Your '} Result: <>{userPassed ? <>Passed </> : <>Failed</>}&nbsp;{calculateScore(quizDataDict)}%</>
                </Typography>
                <QuizHeader quizDataDict={quizDataDict} userPassed={userPassed} hideSuccess={teacherView}/>
                <QuizOverview quizDataDict={quizDataDict}/>
                {(teacherView || feedback === 'detailed' || feedback === 'full') &&
                <DetailedQuestionResult
                    quizDataDict={quizDataDict}
                    expandDefault={teacherView}
                    showAnswerKey={feedback === 'full' || teacherView}/>}
                </>
            }
        </div>
    );
}

function QuizSubmitted(props) {
    return (
        <div className="center-all">
            <SubmittedIcon style={{width: '3rem', height:'3rem'}}/>
            <Typography variant="h4" color="primary">You have successfully submitted your quiz</Typography>
            { props.returnTo ? <Typography variant="h6" color="secondary"><a href={props.returnTo} target="_blank" rel="noopener noreferrer" >Click here to submit your results</a></Typography> : <Typography variant="h6" color="secondary">You may now close this window</Typography> }
        </div>
    );
}

const SubmittedIcon = (props) => (
    <Icon {...props}>
        <img src="/images/successful_submit.svg" style={{width: 'inherit'}}/>
    </Icon>
);

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default withRouter(connect(
    null,
    mapDispatchToProps
)(QuizUserResult));
